// Contém todas as configurações dos menus.
const MenuConfig = {

    // Dashboard
    dashboard: {
        title: "dashboard",
        customer: {
            nonReturning: {
                title: "customers",
                route: "/dashboard/customer/non-returning"
            }
        },
        birthdays: {
            title: "birthdays",
            route: "/dashboard/birthdays"
        }
    },

    // Central de Relatórios: hub com atalhos para os relatórios dos demais módulos.
    reports: {
        title: "reports",
        hub: {
            title: "reports_center",
            route: "/reports"
        },
        employee_statement: {
            title: "employee_statement",
            route: "/reports/employee-statement"
        },
        extra_services: {
            title: "sales_report",
            route: "/reports/sales"
        },
        pot: {
            title: "pot_report",
            route: "/reports/pot"
        },
        financial_summary: {
            title: "employee_financial_summary",
            route: "/reports/financial-summary"
        }
    },

    // Main
    main: {
        title: "main",
        product: {
            title: "products",

            // É necessário a "/" inicial para pegar a rota da raiz.
            route: "/main/product"
        },
        service: {
            title: "services",
            route: "/main/service"
        },
        category: {
            title: "categories",
            route: "/main/category"
        },
        card_flag: {
            title: "card_flags",
            route: "/main/card-flag"
        },
        customer: {
            title: "customers",
            route: "/main/customer"
        },
        vendor: {
            title: "vendors",
            route: "/main/vendor"
        },
        employee: {
            title: "employees",
            route: "/main/employee"
        },
        branch: {
            title: "branches",
            route: "/main/branch"
        },
        branch_working_hours: {
            title: "working_hours",
            route: "/main/branch/working-hours"
        }
    },

    // Agendamentos
    appointment: {
        title: "appointments",
        appointment: {
            title: "appointment_launches",
            route: "/appointment"
        },
        dashboard: {
            title: "schedules",
            route: "/appointment/dashboard"
        },
        review: {
            title: "service_reviews",
            route: "/appointment/reviews"
        },
        block: {
            title: "agenda_blocks",
            route: "/appointment/blocks"
        },
        special_day: {
            title: "special_days",
            route: "/appointment/special-days"
        },
        blocked_customer: {
            title: "blocked_customers",
            route: "/appointment/blocked-customers"
        }
    },

    sales: {
        title: "sales",
        order: {
            title: "sales",
            route: "/sales/order"
        },
        reason: {
            title: "reasons_cancellation",
            route: "/sales/reason"
        },
        commission_rule: {
            title: "commission_rules",
            route: "/sales/commission-rule"
        }
    },

    gamification: {
        title: "gamification.pot",
        score: {
            title: "gamification.score",
            route: "/gamification/score"
        },
        pot: {
            title: "gamification.pot",
            route: "/gamification/pot"
        },
        pot_bonus_rule: {
            title: "pot_bonus_rules",
            route: "/gamification/pot-bonus-rule"
        },
    },

    performance: {
        title: "performance.label",
        plan: {
            title: "performance.plans",
            route: "/performance/plan"
        },
        employee_plan: {
            title: "performance.employee_plans",
            route: "/performance/employee-plan"
        },
        dashboard: {
            title: "performance.dashboard",
            route: "/performance/dashboard"
        },
        reports: {
            title: "performance.reports.title",
            route: "/performance/reports"
        },
        appointment_growth: {
            title: "performance.reports.appointment_growth",
            route: "/performance/reports/appointment-growth"
        },
        monthly_highlight: {
            title: "performance.reports.monthly_highlight",
            route: "/performance/reports/monthly-highlight"
        },
    },


    subscription: {
        title: "subscriptions",
        dashboard: {
            title: "dashboard",
            route: "/subscription/dashboard"
        },
        plan: {
            title: "plans",
            route: "/subscription/plan"
        },
        subscription: {
            title: "subscribers",
            route: "/subscription/subscribers"
        },
        charge: {
            title: "charges",
            route: "/subscription/charges"
        },
        // Permissão própria (subscription.club_partner.view): quem cuida dos planos nem sempre cuida
        // dos parceiros, e o Clube pode ser liberado só em alguns planos do SaaS.
        club_partner: {
            title: "club_partners",
            route: "/subscription/club-partners"
        }
    },

    integration: {
        title: "integrations",

        payment_provider: {
            title: "payment_provider",
            route: "/superadmin/payment-provider"
        },
        asaas_settings: {
            title: "asaas_settings",
            route: "/superadmin/asaas/settings"
        },
        celcoin_settings: {
            title: "celcoin_settings",
            route: "/superadmin/celcoin/settings"
        },
    },

    chat_bot: {
        title: "chat_bot",
        dashboard: {
            title: "whatsapp_dashboard",
            route: "/integration/whatsapp/dashboard"
        },
        bot: {
            title: "chatbot_assistant",
            route: "/integration/whatsapp/bots"
        },
        conversation: {
            title: "whatsapp_conversations",
            route: "/integration/whatsapp/conversations"
        },
        attendance: {
            title: "whatsapp_attendance_metrics",
            route: "/integration/whatsapp/attendance"
        },
        settings: {
            title: "chatbot_settings",
            route: "/integration/whatsapp/settings"
        }
    },

    identity: {
        title: "identity",
        user: {
            title: "users",
            route: "/identity/user"
        },
        group: {
            title: "groups",
            route: "/identity/group"
        }
    },

    // Controle de Estoque
    stock_control: {
        title: "stock_management",
        stock: {
            title: "check_stock",
            route: "/stock-control/stock"
        },
        restock: {
            title: "restock",
            route: "/stock-control/restock"
        },
    },

    // Fluxo de Caixa
    cash_flow: {
        title: "cash_flow.label",
        cash_registers: {
            title: "cash_flow.cash_registers",
            route: "/cash-flow/cash"
        },
        transaction: {
            title: "cash_flow.transactions",
            route: "/cash-flow/transaction"
        },
        payable_receivable: {
            title: "cash_flow.accounts_payable_receivable",
            route: "/cash-flow/accounts-payable-receivable"
        },
        categories: {
            title: "cash_flow.categories",
            route: "/cash-flow/categories"
        },
        dre_report: {
            title: "cash_flow.dre_report",
            route: "/cash-flow/dre-report"
        },
        import_data: {
            title: "cash_flow.import_data",
            route: "/cash-flow/import-data"
        },
        advance: {
            title: "cash_flow.advances",
            route: "/cash-flow/advances"
        },
        employee_consumption: {
            title: "cash_flow.employee_consumptions",
            route: "/cash-flow/employee-consumptions"
        },
        employee_payment: {
            title: "cash_flow.employee_payments",
            route: "/cash-flow/employee-payments"
        },
        employee_bonus: {
            title: "cash_flow.employee_bonuses",
            route: "/cash-flow/employee-bonuses"
        },
    },

    // Central de Ajuda: tutoriais em vídeo do produto. Não tem module porque não é
    // funcionalidade contratada, e sim material de treinamento para qualquer usuário.
    // Plano contratado pela própria empresa. Fica fora de superadmin de propósito: o módulo
    // de Cobrança SaaS é do administrador da plataforma, e esta é a visão que o cliente tem
    // do contrato dele. O acesso é pelo menu do perfil (HeaderProfile), não pela barra
    // lateral: é consulta sobre a conta, não um módulo de trabalho.
    my_plan: {
        title: "my_plan.title",
        current: {
            title: "my_plan.current",
            route: "/my-plan"
        }
    },

    help: {
        title: "help.title",
        tutorials: {
            title: "help.tutorials",
            route: "/help"
        }
    },

    superadmin: {
        title: "administration",
        company: {
            title: "Empresas",
            route: "/superadmin/company"
        },
        company_api: {
            title: "company_api.credentials",
            route: "/superadmin/company-apis"
        },
        whatsapp: {
            title: "superadmin_whatsapp.title",
            route: "/superadmin/whatsapp"
        },
        announcement: {
            title: "Comunicados",
            route: "/superadmin/announcements",
            newRoute: "/superadmin/announcements/new"
        },
        saas_billing: {
            title: "Cobrança SaaS",
            route: "/superadmin/saas-billing",
            plansRoute: "/superadmin/saas-billing/plans",
            contractsRoute: "/superadmin/saas-billing/contracts",
            webhooksRoute: "/superadmin/saas-billing/webhooks"
        }
    },
}

export default MenuConfig;
